const baseMarketplaceCampaignTheme = {
    accent: '#7367F0',
    accentStrong: '#5E50EE',
    accentSoft: '#F7F5FF',
    accentSoftAlt: '#FBFAFF',
    accentBorder: '#E2DBFF',
    accentMuted: '#CFC6FF',
    accentContrast: '#FFFFFF',
    secondaryAccent: '#B66CFF',
    highlight: '#FF6FAE',
    textPrimary: '#4F4B66',
    textSecondary: '#7C7792',
    textMuted: '#9A94AD',
    surface: '#FFFFFF',
    surfaceAlt: '#FCFBFF',
    heroGradient: 'linear-gradient(135deg, #7367F0 0%, #8D7CFF 60%, #FF6FAE 100%)',
    sectionGradient: 'linear-gradient(180deg, #FCFBFF 0%, #FFFFFF 100%)',
    cardGradient: 'linear-gradient(135deg, #F7F5FF 0%, #FBFAFF 100%)',
    buttonGradient: 'linear-gradient(135deg, #7367F0 0%, #5E50EE 100%)',
    buttonShadow: '0 14px 28px rgba(115, 103, 240, 0.24)',
    cardShadow: '0 16px 34px rgba(115, 103, 240, 0.10)',
    stepBadgeGradient: 'linear-gradient(135deg, #7367F0 0%, #A48EFF 100%)',
    stepText: '#FFFFFF',
    stepCardBorder: '#D9D9D9',
    heroChipBackground: 'rgba(255, 255, 255, 0.16)',
    heroChipBorder: '1px solid rgba(255, 255, 255, 0.22)',
    heroGlow: 'rgba(255, 255, 255, 0.18)',
    buttonText: '#FFFFFF',
};

export const marketplaceCampaignThemes = {
    cashea: {
        ...baseMarketplaceCampaignTheme,
        marketplaceName: 'Cashea',
        accent: '#FFF44A',
        accentStrong: '#7A5C00',
        accentSoft: '#FFFCE0',
        accentSoftAlt: '#FFFEF4',
        accentBorder: '#F1E37A',
        accentMuted: '#F7ED9B',
        accentContrast: '#3A2B00',
        secondaryAccent: '#FFD93D',
        highlight: '#FFC400',
        textPrimary: '#332800',
        textSecondary: '#6B5520',
        textMuted: '#8F7A45',
        surfaceAlt: '#FFFDF2',
        heroGradient: 'linear-gradient(135deg, #FFF44A 0%, #FFED3D 58%, #FFD91A 100%)',
        sectionGradient: 'linear-gradient(180deg, #FFFEF7 0%, #FFFFFF 100%)',
        cardGradient: 'linear-gradient(135deg, #FFFCE0 0%, #FFF9CC 100%)',
        buttonGradient: 'linear-gradient(135deg, #1A1A1A 0%, #000000 100%)',
        buttonShadow: '0 14px 28px rgba(0, 0, 0, 0.22)',
        cardShadow: '0 16px 34px rgba(17, 17, 17, 0.08)',
        stepBadgeGradient: 'linear-gradient(135deg, #1A1A1A 0%, #000000 100%)',
        stepText: '#FFFFFF',
        stepCardBorder: '#CFCFCF',
        heroChipBackground: 'rgba(58, 43, 0, 0.06)',
        heroChipBorder: '1px solid rgba(58, 43, 0, 0.12)',
        heroGlow: 'rgba(255, 255, 255, 0.24)',
        buttonText: '#FFFFFF',
    },
};

export function getMarketplaceCampaignTheme(marketplaceKey) {
    return marketplaceCampaignThemes[marketplaceKey] || baseMarketplaceCampaignTheme;
}
